import { NgModule } from '@angular/core';
import { S123gS123m01Component } from './s123g-s123m01.component';
import { SharedModule } from './../../shared.module';

@NgModule({
    imports: [SharedModule],
    exports: [],
    declarations: [S123gS123m01Component]
})
export class S123gModule { }

